<template>
    <Modal :open="displayModal" title="Record Social Payment" size="large" modalIcon="fad fa-coins"
        modalIconColor="bg-green-100 text-green-700" :showEscapeButton="true" :showAcceptButton="!loadingInitial"
        :acceptButtonProgress="isProgressing" :disableAcceptButton="(total == 0)" acceptButtonText="Record Payment"
        @close="displayModal = false" @onSuccess="recordPayment" ref="modal">
        <div class="bg-red-600 p-4 rounded mb-4" v-if="error"><strong class="font-medium text-white">A check number is
                required.</strong></div>
        <div class="text-center text-4xl py-8" v-if="loadingInitial">
            <i class="far fa-circle-notch fa-spin"></i>
        </div>
        <div class="overflow-hidden ring-2 ring-black ring-opacity-10 mt-2 -mx-6" v-if="!loadingInitial">
            <table class="min-w-full divide-y divide-gray-300">
                <thead class="bg-gray-50">
                    <tr>
                        <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                        </th>
                        <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                            Month</th>
                        <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Amount</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 bg-white">
                    <tr v-for="report in reports">
                        <td
                            class="whitespace-nowrap py-4 pl-4 sm:pl-6 pr-3 text-sm font-medium text-gray-900 sm:pl-6 w-8">
                            <input id="comments" name="comments" type="checkbox"
                                class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                v-model="report.checked" />
                        </td>
                        <td class="whitespace-nowrap py-4 px-4 text-sm font-medium text-gray-900 sm:pl-6 w-full">{{
                            report.granularity_id | displayMonthYear
                        }}</td>
                        <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 pr-4 sm:pr-6">{{
                            report.stringer_earnings | displayMoney
                        }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <th scope="col"
                            class="py-3.5 pl-4 pr-3 text-left text-sm font-medium text-gray-900 sm:pl-6 text-right"
                            colspan="2">
                            Payment Total
                        </th>
                        <th scope="col" class="px-3 py-3.5 text-left text-sm font-medium text-gray-900">
                            {{ totalOfSelectedReports() | displayMoney }}
                        </th>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div class="mt-4" v-if="!loadingInitial">
            <label for="checkNum" class="block text-sm font-medium text-gray-700">Payment Reference</label>
            <div class="w-full flex flex-row space-x-4">
                <div class="w-1/2 mt-1 flex rounded-md shadow-sm">
                    <span
                        class="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3 text-gray-500 sm:text-sm"
                        v-if="dd == true">Reference</span>
                    <span
                        class="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3 text-gray-500 sm:text-sm"
                        v-if="dd == false">Check</span>
                    <input type="number" name="checkNum" id="checkNum"
                        class="block w-full min-w-0 flex-1 rounded-none rounded-r-md border-gray-300 px-3 py-2 focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                        v-model="checkNumber">
                </div>
                <div class="w-1/2 relative flex items-center content-center ">

                    <div class="flex h-6 items-center">
                        <input id="dd" aria-describedby="dd-description" name="dd" type="checkbox"
                            class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-600" v-model="dd">
                    </div>
                    <div class="ml-3 text-sm leading-6">
                        <label for="dd" class="font-medium text-gray-900">Direct Deposit</label>
                    </div>

                </div>
            </div>
        </div>
    </Modal>
</template>

<script>
import * as Config from "@/config";
import { mapActions } from "vuex";
import moment from "moment"

import Modal from "@/components/Modal";

export default {
    data() {
        return {
            displayModal: false,
            loadingInitial: true,
            data: {},
            reports: [],
            isProgressing: false,
            reportSelected: {},
            total: 0,
            checkNumber: null,
            error: false,
            dd: false,
        };
    },

    components: {
        Modal
    },


    mounted() {
        this.$nextTick(
            function () {
                this.$eventBus.$on("admin-record-social-payment-open-modal", this.open);
            }.bind(this)
        );
    },

    destroyed() {
        this.$eventBus.$off("admin-arecord-social-payment-open-modal", this.open);
    },

    watch: {
        reportSelected: function (val) {
            console.log(val)
        }
    },

    methods: {
        ...mapActions(["addToastMessage"]),
        async open(data) {
            this.loadingInitial = true;
            this.displayModal = true;
            this.checkNumber = null;
            this.data = data
            await this.loadReportData()
            this.loadingInitial = false
            this.dd = false
        },

        async loadReportData() {
            let response = await this.$http.get(
                Config.apiPath + "/api/v2/admin/youtube/user_reports/" + this.data.user_id + "?status=approved"
            );
            let reports = response.data;
            reports.forEach((report) => {
                report.checked = true
            })
            this.reports = reports;
        },
        totalOfSelectedReports() {
            let total = 0;
            this.reports.forEach((report) => {
                if (report.checked) {
                    total += report.stringer_earnings;
                }
            })
            this.total = total
            return total
        },
        async recordPayment() {
            if (this.checkNumber == null || this.checkNumber == "") {
                this.error = true;
                return;
            }
            this.error = false;
            let selectedReports = [];
            this.reports.forEach((report) => {
                if (report.checked) {
                    selectedReports.push(report.id)
                }
            })
            try {
                let res = await this.$http.post(
                    Config.apiPath + "/api/v2/admin/youtube/payment/record", {
                    userId: this.data.user_id,
                    reportIds: selectedReports,
                    checkNumber: this.checkNumber,
                    dd: this.dd
                }
                );
                this.$eventBus.$emit("admin-payment-recorded-refresh-data");
                this.addToastMessage({
                    title: "Success",
                    text:
                        "The payout has been successfully recorded.",
                    type: "success"
                });
                this.displayModal = false;
            } catch (e) {
                alert('error')
            }
            console.log(res.data)

        },
    },
    filters: {
        displayMoney: function (value) {
            var formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD"
            });
            return formatter.format(value);
        },
        displayMonthYear: function (data) {
            return moment(data, "YYYYMM").format("MMMM YYYY");
        },
    }
};
</script>
